import React from 'react';
import { routes, ASYNC_REPORTS_TYPE } from 'constants/config';
import request from 'utils/request_ajax';
import ReportOption from './ReportOption';

class TagReportsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groups: [],
      tags: [],
    };
    this.fetchData = this.fetchData.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    request.get(routes.GROUPS).then(({ groups }) => this.setState({ groups }));
    request.get(routes.TAGS).then(({ tags }) => this.setState({ tags }));
  }

  render() {
    return (
      this.state.groups.length > 0 && (
        <section className="DataCard DataCard--containsCards fd-c mb-24">
          <ReportOption
            csvRoute={routes.INSIGHTS.TAGS.TAG_ACTIVITY}
            groups={this.state.groups}
            title={t('insights.tag_reports.tags_for_group_summary.title')}
            subtitle={t('insights.tag_reports.tags_for_group_summary.subtitle')}
            validate={({ groupId }) => !!groupId}
            pendoClassName="trk_link_learning_training-activity-organized-by-tag-download"
          />
          <ReportOption
            csvRoute={routes.INSIGHTS.TAGS.LESSON_ACTIVITY}
            groups={this.state.groups}
            tags={this.state.tags}
            title={t('insights.tag_reports.lessons_for_group_summary.title')}
            subtitle={t(
              'insights.tag_reports.lessons_for_group_summary.subtitle',
            )}
            validate={({ groupId, tagId }) => !!groupId && !!tagId}
            pendoClassName="trk_link_learning_lesson-activity-within-a-tag-download"
          />
          <ReportOption
            useReportingApp
            asyncReportType={
              ASYNC_REPORTS_TYPE.EXPORT_LEARNERS_FOR_GROUP_TAG_REPORT
            }
            groups={this.state.groups}
            tags={this.state.tags}
            title={t('insights.tag_reports.learners_for_group_summary.title')}
            subtitle={t(
              'insights.tag_reports.learners_for_group_summary.subtitle',
            )}
            validate={({ groupId, tagId }) => !!groupId && !!tagId}
            pendoClassName="trk_link_learning_learner-activity-within-a-tag-download"
          />
        </section>
      )
    );
  }
}

export default TagReportsContainer;
